export const defaultStoreConfig = {
  storeConfig: {
    copyright: '© 2025 NAOS. Все права защищены. ООО «НАОС ВОСТОК»',
    default_title:
      'NAOS | Официальный интернет-магазин BIODERMA, Institut Esthederm и Etat Pur',
    store_name:
      'NAOS | Официальный интернет-магазин BIODERMA, Institut Esthederm и Etat Pur',
    store_ogrn: 'ОГРН:1177746954110',
    store_city: 'г. Москва',
    store_region: 'Российская Федерация',
    store_schedule: '9:00 – 21:00 ежедневно',
    store_street:
      'вн.тер.г. Муниципальный округ Басманный, пер. Нижний Сусальный, д. 5, стр. 4, помещ. I, ком. 7, 8, 9.',
    store_telephone: '8 800 775 93 59',
    store_vat_number: 'ИНН:7720394094 ',
    store_zip_code: '105064',
    recipient_email: 'support@ru.naos.com',
    advertising_warning_text: '',
    search_suggestion_limit: '5'
  }
};
